export default __webpack_public_path__ + "static/media/plain-sticker-H.1d8723d3.png";